<template>
  <v-container text-xs-center>
    <v-layout row align-center>
      <v-flex>
        <h1 class="primary--text">{{ title }}</h1>

        <p>{{ content }}</p>

        <router-link :to="{ name: 'ApplicationSelector' }">
          <v-btn :to="`/`" color="ml-0 primary" outlined> Go to main page </v-btn>
        </router-link>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'error-view',
  props: {
    title: {
      type: String,
      default: 'Oops, 404',
    },
    content: {
      type: String,
      default: 'The page you were looking for does not exist',
    },
  },
};
</script>
